import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_GET_ALL_CODES,
  SUCCESS_GET_ALL_CODES,
  FAILURE_GET_ALL_CODES,
  LOADING_GET_ALL_CODES,
} = documentationActions;

function* getAllCodes(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_ALL_CODES });
    const response = yield call(
      templateService.getCPTorICDcodes,
      action.payload,
      action.patientUuid
    );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_CODES, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_CODES, payload: error });
  }
}

function* getAllCodesSaga() {
  yield takeEvery(REQUEST_GET_ALL_CODES, getAllCodes);
}

export default getAllCodesSaga;
